import React, { useCallback, useRef, useState, Fragment } from "react";
import useLocations from "./useLocations.js";
import { ContentWithTitle, ShellButton } from "../Shell/index.js";
import { Popover, Text } from "@bookingcom/bui-react";
import { AutoComplete } from "../AutoComplete/index.js";
import { TransportAirplaneArriveIcon, TransportAirplaneDepartIcon } from "@bookingcom/bui-assets-react/streamline";
import { LOCATION_DATA_UI_NAME, ANYWHERE } from "../../utils/constants.js";
import { t } from "@bookingcom/lingojs-react";
import styles from "./LocationsDropDown.module.css";
export default function LocationsDropDown(props) {
    const { type, segmentIndex, position = "bottom-start", errorVariant = "tooltip", size, forcePosition = true } = props;
    const { selectedLocationsText, trackV2, errorMessage, multiSelectVariant, searchType, i18n, canShowFlyAnywhere } = useLocations({
        type,
        segmentIndex
    });
    const [showDropDown, setShowDropDown] = useState(false);
    const buttonRef = useRef(null);
    const handleOnFinish = useCallback(() => {
        setShowDropDown(false);
    }, []);
    const handleOnButtonClick = useCallback(() => {
        trackV2(type === "from" ? "click_origin" : "click_destination");
        setTimeout(() => setShowDropDown(true), 0);
    }, [type, trackV2]);
    const handlePopoverOnOpen = useCallback(() => {
        setShowDropDown(true);
    }, []);
    const handlePopoverOnClose = useCallback(() => {
        setShowDropDown(false);
    }, []);
    const errorId = `location_input_${type}_${segmentIndex}_error`;
    return (React.createElement(React.Fragment, null,
        React.createElement(ShellButton, { icon: type === "from" ? TransportAirplaneDepartIcon : TransportAirplaneArriveIcon, errorMessage: showDropDown ? undefined : errorMessage, errorVariant: errorVariant, errorId: errorId, tabIndex: 0, ref: buttonRef, "data-ui-name": `${LOCATION_DATA_UI_NAME[type]}_${segmentIndex}`, "data-ui-error": Boolean(errorMessage), onClick: handleOnButtonClick, size: size, halfVerticalPadding: true, alignIcon: "center", "aria-invalid": !!errorMessage, "aria-describedby": searchType === "MULTISTOP" ? `a11y_multi_segment_description_${segmentIndex}` : undefined },
            React.createElement(ContentWithTitle, { title: type === "from"
                    ? i18n.trans(t("flights_searchbox_leaving_from"))
                    : i18n.trans(t("flights_searchbox_going_to")), content: selectedLocationsText?.map((tx, idx) => (React.createElement(Fragment, { key: tx.code + idx },
                    tx.code && tx.type !== "COUNTRY" ? (React.createElement("b", null,
                        tx.code === ANYWHERE ? i18n.trans(t("flights_search_destination_anywhere")) : tx.code,
                        " ")) : null,
                    tx.type === "COUNTRY" ? React.createElement("b", null,
                        tx.name,
                        " ") : tx.name,
                    idx < selectedLocationsText.length - 1 ? (React.createElement(Text, { tagName: "span", variant: "body_2" }, " · ")) : null))) })),
        React.createElement(Popover, { forcePosition: forcePosition, active: showDropDown, triggerRef: buttonRef, position: position, trapFocusMode: "soft", hideClose: true, keepMounted: false, navigationMode: "tab-and-arrows", triggerType: "click", disableAnimation: true, onOpen: handlePopoverOnOpen, onClose: handlePopoverOnClose },
            React.createElement(Popover.Content, null,
                React.createElement("div", { className: styles.container },
                    React.createElement(AutoComplete, { type: type, autoFocusInput: multiSelectVariant !== 2 && multiSelectVariant !== 3, segmentIndex: segmentIndex, canShowFlyAnywhere: canShowFlyAnywhere, onFinish: handleOnFinish }))))));
}
